import css from './Description.module.scss';
import classNames from 'classnames';

export default function Description({children, isDark, isWhite, cn}) {
  return (
    <p className={classNames(css.description, cn, {[css.dark]: isDark}, {[css.white]: isWhite})}>
      {children}
    </p>
  );
}